import React from 'react';
import { LabelFormat } from '../types';
import './PrintControls.css';

interface PrintControlsProps {
  selectedFormat: LabelFormat;
  onFormatChange: (format: LabelFormat) => void;
  dataCount: number;
}

const PrintControls: React.FC<PrintControlsProps> = ({
  selectedFormat,
  onFormatChange,
  dataCount
}) => {
  const formats = [
    {
      id: '65-1' as LabelFormat,
      name: '65-1 Format',
      description: '38.0 × 21.2 mm (65 nalepnica po listu)',
      labelsPerSheet: 65
    },
    {
      id: '21-3' as LabelFormat,
      name: '21-3 Format',
      description: '63.5 × 38.1 mm (21 nalepnica po listu)',
      labelsPerSheet: 21
    },
    {
      id: '40-2' as LabelFormat,
      name: '40-2 Format',
      description: '48.5 × 25.4 mm (40 nalepnica po listu)',
      labelsPerSheet: 40
    }
  ];

  const selectedFormatConfig = formats.find(f => f.id === selectedFormat);
  const sheetsNeeded = selectedFormatConfig 
    ? Math.ceil(dataCount / selectedFormatConfig.labelsPerSheet)
    : 0;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-controls">
      <h2>Podešavanja štampanja</h2>
      
      <div className="format-selection">
        <h3>Odaberite format nalepnica:</h3>
        <div className="format-options">
          {formats.map(format => (
            <label key={format.id} className="format-option">
              <input
                type="radio"
                name="format"
                value={format.id}
                checked={selectedFormat === format.id}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFormatChange(e.target.value as LabelFormat)}
              />
              <div className="format-info">
                <strong>{format.name}</strong>
                <span>{format.description}</span>
              </div>
            </label>
          ))}
        </div>
      </div>

      <div className="print-info">
        <div className="info-item">
          <span className="info-label">Ukupno stavki:</span>
          <span className="info-value">{dataCount}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Potrebno listova:</span>
          <span className="info-value">{sheetsNeeded}</span>
        </div>
      </div>

      <button className="print-button" onClick={handlePrint}>
        🖨️ Štampaj nalepnice
      </button>
    </div>
  );
};

export default PrintControls; 